import axios, { AxiosInstance } from "axios";
import { StoreType } from "./localStorage";

const baseURl = process.env.REACT_APP_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;
const adminApiKey = process.env.REACT_APP_API_ADMIN_KEY;

// Create an Axios instance
const api: AxiosInstance = axios.create({
  baseURL: baseURl, // replace with your API URL
  timeout: 30000,
  headers: {
    "x-api-key": apiKey,
    "x-admin-api-key": adminApiKey,
    "Content-Type": "application/json",
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(StoreType.AUTH_TOKEN);
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log("error", error);

    if (error.response && error.response.status === 401) {
      // Handle Unauthorized error (e.g., logout or redirect to login page)
    }
    return Promise.reject(error);
  }
);

export default api;
